import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrophy = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14 17H13C12.2044 17 11.4413 16.6839 10.8787 16.1213C10.3161 15.5587 10 14.7956 10 14V9H14",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26 17H27C27.7956 17 28.5587 16.6839 29.1213 16.1213C29.6839 15.5587 30 14.7956 30 14V9H26",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 27V23",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 23C18.4087 23 16.8826 22.3679 15.7574 21.2426C14.6321 20.1174 14 18.5913 14 17V9H26V17C26 18.5913 25.3679 20.1174 24.2426 21.2426C23.1174 22.3679 21.5913 23 20 23Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26 31H14C14 29.9391 14.4214 28.9217 15.1716 28.1716C15.9217 27.4214 16.9391 27 18 27H22C23.0609 27 24.0783 27.4214 24.8284 28.1716C25.5786 28.9217 26 29.9391 26 31Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgTrophy);
export default ForwardRef;
